import { TitleBarComponent } from 'src/app/base/shared/title-bar/title-bar.component';
import { SideNavigationService } from './../../base/side-navigation/side-navigation.service';
import { Component } from '@angular/core';

@Component({
    selector: 'app-home',
    templateUrl: './home.component.html',
    styleUrls: ['./home.component.scss'],
    imports: [TitleBarComponent]
})
export class HomeComponent {
  constructor(private sideNavigationService: SideNavigationService) {
    this.sideNavigationService.navigationData = [];
  }
}
